import type { TiptapState } from '@/types';

import type { TocItem } from './types';

const getItems = (data: TiptapState): TocItem[] => {
  const filteredBlocks =
    data.content?.filter(
      (block) =>
        block.attrs?.anchorEnabled &&
        block.attrs?.anchorId &&
        block.attrs?.anchorTitle &&
        (block.attrs?.anchorIncludeInToc ?? true),
    ) || [];

  return filteredBlocks.map((block, i) => {
    const prevItem = i > 0 ? filteredBlocks[i - 1] : null;
    let fallbackDepth = prevItem?.attrs?.depth || 1;

    if (prevItem && prevItem.type === 'heading') {
      fallbackDepth += 1;
    }

    return {
      id: block.attrs?.anchorId || '',
      title: block.attrs?.anchorTitle || '',
      isHeading: block.type === 'heading',
      depth: block.attrs?.level || fallbackDepth,
      children: [],
    };
  });
};

const findParentListForItem = (list: TocItem[], item: TocItem): TocItem[] => {
  if (list.length === 0) return list;
  if (list[list.length - 1].depth >= item.depth) return list;
  return findParentListForItem(list[list.length - 1].children, item);
};

const createNestedItems = (items: TocItem[]): TocItem[] => {
  const result: TocItem[] = [];

  items.forEach((item) => {
    const targetArray = findParentListForItem(result, item);
    targetArray.push(item);
  });

  return result;
};

export const getTableOfContents = (data: TiptapState) => {
  const items = getItems(data);
  const nestedItems = createNestedItems(items);
  return nestedItems;
};
